import { readCookie, writeCookie } from '@/tools/tools';
/**
 * getters
 */
export var getters = {
  invoicelist: function invoicelist(state) {
    return state.invoicelist;
  }
};
/**
 * mutations
 */
export var mutations = {
  // 发票列表
  INVOICELIST: function INVOICELIST(state, payload) {
    state.invoicelist = payload;
    writeCookie('invoicelist', state.invoicelist);
  },
  // 编辑发票
  INVOICEEDIT: function INVOICEEDIT(state, payload) {
    state.invoiceedit = payload;
    writeCookie('invoiceedit', state.invoiceedit);
  },
  // 新增时清空当前编辑地址
  CLEARINVOICE: function CLEARINVOICE(state) {
    state.invoiceedit = {};
    writeCookie('invoiceedit', state.invoiceedit);
  },
  // 选择发票
  SELECTINVOICE: function SELECTINVOICE(state, payload) {
    state.invoiceselect = payload;
    // writeCookie('invoiceselect', state.invoiceselect);
  },
  // 不开发票清空选择发票
  CLEARSELECTINVOICE: function CLEARSELECTINVOICE(state) {
    state.invoiceselect = {};
    // writeCookie('invoiceselect', state.invoiceselect);
  },
  // 清空选择发票
  CLEARESELECTINVOICE: function CLEARESELECTINVOICE(state) {
    state.invoiceselect = {};
  }
};
/**
 * actions
 */
export var actions = {
  setinvoicelist: function setinvoicelist(_ref, payload) {
    var commit = _ref.commit;
    commit('INVOICELIST', payload);
  },
  invoiceedit: function invoiceedit(_ref2, payload) {
    var commit = _ref2.commit;
    commit('INVOICEEDIT', payload);
  },
  clearEditInvoice: function clearEditInvoice(_ref3) {
    var commit = _ref3.commit;
    commit('CLEARINVOICE');
  }
};
/**
 * state
 */
export var state = {
  invoicelist: readCookie('invoicelist') ? readCookie('invoicelist') : [],
  invoiceedit: readCookie('invoiceedit'),
  invoiceselect: {}
};
var namespaced = true;
export var invoice = {
  namespaced: namespaced,
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
};